import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CiudadanosValidarComponent } from './ciudadanos-validar.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    CiudadanosValidarComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    CiudadanosValidarComponent
  ]
})
export class CiudadanosValidarModule { }
